import { Dispatch, Action } from 'redux'
import { HeaderOneTextMapDispatchReturnType } from './types/HeaderOneTextMapDispatchReturnType'

export const HeaderOneTextMapDispatch = (
  _dispatch: Dispatch<Action>
): HeaderOneTextMapDispatchReturnType => {
  return {}
}
